import React, { useState } from "react";
import cookie from "react-cookies";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SearchForm = () => {
  const [name, setName] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const navigate = useNavigate();

  const handleSubmit = (search: string) => {
    if (search === "") search = "all";
    navigate(`/search/${search}`);
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      handleSubmit(e.target.value);
    }
  };

  return (
    <div className="flex gap-3.5 sm:flex-col h-[50px] sm:h-[114px]">
      <div className="relative flex grow max-w-[639px]">
        <input
          type="text"
          className="w-full h-[50px] pl-[16px] pr-14 outline-none text-xl font-opensans text-main leading-[16px]"
          placeholder="I'M LOOKING FOR..."
          readOnly={
            cookie.load("user")?.organization.toLowerCase() !== "gyde"
              ? true
              : false
          }
          onClick={() => {
            if (cookie.load("user") === undefined) {
              toast.warning("Please login to search!");
              return;
            }
            if (cookie.load("user").organization.toLowerCase() !== "gyde") {
              toast.warning("You are not in Gyde Organization!");
              return;
            }
          }}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div
        className="relative flex grow max-w-[639px]"
        onClick={() => toast.warning("We are currently only in Baltimore, MD.")}
      >
        <input
          type="text"
          className="w-full h-[50px] pl-[16px] pr-14 outline-none text-xl font-opensans text-main leading-[16px]"
          placeholder="IN BALTIMORE, MD"
          readOnly
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );
};

export default SearchForm;
